<template>
    <Main>
        <div slot="main" class="main breeder">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
                <div v-if="goBackShow" class="gobcak" @click="goBack"><img src="../../assets/return.png"
                        alt=""><span>返回</span>
                </div>

            </div>
            <div class="content" v-if="refreShow">
                <div class="left">
                    <div class="l_t">
                        <div class="server">
                            <div>
                                <span class="card_">活畜增长趋势</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <el-select class="select" v-model="animalTime" placeholder="2023" @change="timeChange"
                                style="margin-right: 0.13rem;font-size:0.13rem">
                                <el-option v-for="item in timeList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- <div class="date">
                                <span @click="serviceStatusBtn('first')"
                                    :class="{ active: serviceStatus === 'first' }">近1月</span>
                                <span @click="serviceStatusBtn('three')"
                                    :class="{ active: serviceStatus === 'three' }">近3月</span>
                                <span @click="serviceStatusBtn('six')"
                                    :class="{ active: serviceStatus === 'six' }">近6月</span>
                            </div> -->
                        </div>
                        <div class="amount">
                            <div class="amountOne">
                                <span class="hand">活畜总数</span>
                                <ul>
                                    <li v-for="(item, i) in livestockCount" :key="i">{{ item }}</li>
                                </ul>
                            </div>
                            <div class="add">
                                <div class="add_item">
                                    <span>牛：</span>
                                    <span>{{ liveAnimals.cowCount || 0 }}</span>
                                </div>
                                <div class="add_item">
                                    <span>羊：</span>
                                    <span>{{ liveAnimals.sheepCount || 0 }}</span>
                                </div>
                                <div class="add_item">
                                    <span>马：</span>
                                    <span>{{ liveAnimals.horseCount || 0 }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="add_total">
                            <div class="add_item">
                                <span class="num">{{ trend.totalOutNum }}</span>
                                <div style="margin-top: 0.11rem;">
                                    <span>累计出栏</span>
                                </div>
                            </div>
                            <div class="add_item">
                                <span class="num">{{ trend.totalInNum }}</span>
                                <div style="margin-top: 0.11rem;">
                                    <span>累计入栏</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="add_item">
                            <span class="num">{{ trend.increment || 0 }}</span>
                            <div style="margin-top: 0.11rem;">
                                <span>累计出栏</span>
                            </div>
                            <span :class="{ active_1: trend.code != 0 }">环比 <i>{{
                                trend.linkRelativeRatio
                            }}</i>
                            </span>
                            <img v-if="data_Map.flag === 1" src="../../assets/icon_down_1.png" alt="">
                            <img v-else src="../../assets/icon_up_1.png" alt="">
                        </div>
                        <div class="add_item" style="margin-left: .6rem;">
                            <span class="num">{{ trend.increment || 0 }}</span>
                            <div style="margin-top: 0.11rem;">
                                <span>累计入栏</span>
                            </div>
                            <span :class="{ active_1: trend.code != 0 }">环比 <i>{{
                                trend.linkRelativeRatio
                            }}</i>
                            </span>
                            <img v-if="data_Map.flag === 1" src="../../assets/icon_down_1.png" alt="">
                            <img v-else src="../../assets/icon_up_1.png" alt="">
                        </div> -->
                        <div id="lineChart" class="line_chart"></div>
                    </div>
                    <div class="l_b">
                        <div class="server">
                            <div>
                                <span class="card_">养殖规模分布</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                        </div>
                        <div id="barChart" class="bar_chart"></div>
                    </div>
                </div>
                <div class="right">
                    <div class="top">
                        <div class="map_box">
                            <div class="server">
                                <div>
                                    <span class="card_">养殖户区域分布</span>
                                    <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                                </div>
                            </div>
                            <div class="center">
                                <div class="text_n">
                                    <span>养殖户</span>
                                    <span>{{ liveAnimals.farmerCount || 0 }}</span>
                                </div>
                                <div class="text_n">
                                    <span>个人牧场</span>
                                    <span>{{ typeValue['个人牧场'] || 0 }}</span>
                                </div>
                                <div class="text_n">
                                    <span>家庭牧场</span>
                                    <span>{{ typeValue['家庭牧场'] || 0 }}</span>
                                </div>
                                <div class="text_n">
                                    <span>合作社</span>
                                    <span>{{ typeValue['合作社'] || 0 }}</span>
                                </div>
                                <!-- <div class="text_n">
                                    <span>预警</span>
                                    <span>{{ warnNum || 0 }}</span>
                                </div> -->
                                <!-- <div class="text_n">
                                    <span style="height:0.5rem;line-height: 0.4rem;">{{ total }}</span>
                                    <span>养殖户(家)</span>
                                </div>
                                <div class="text_n">
                                    <span style="height:0.5rem;line-height: 0.4rem;">{{
                                        farmerData.properties }}</span>
                                    <span>畜牧科技师服务养殖户数</span>
                                </div>
                                <div class="text_n" style="margin-left: 1.1rem;" @click="showWatch">
                                    <span style="height:0.5rem;line-height: 0.4rem;">{{ warnNum }}</span>
                                    <span>预警总数</span>
                                </div> -->
                            </div>
                            <!-- v-if="isShowMap" -->
                            <div id="mapBox" @click="imgPop">
                                <img src="../../assets/Aershan1.png" alt="">
                                <el-image ref="previewImg" style="display: none;" class="AershanImg"
                                    :preview-src-list="srcList" :on-close="closeImgViewer">
                                </el-image>
                                <!-- <img src="../../assets/Aershan.png" alt=""> -->
                            </div>
                        </div>
                        <div class="ranght">
                            <div class="server">
                                <div>
                                    <span class="card_">饲草料价格趋势</span>
                                    <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                                </div>
                            </div>
                            <!-- <dv-active-ring-chart :config="config1" id="pieChart" /> -->
                            <div id="pieChart"></div>
                            <!-- <div class="lenged">
                                <div v-for="(item, i) in farmerKindDis" :key="i">
                                    <span :style='{
                                        backgroundColor: i == 0 ? "#3AFFFB" : i == 1 ? "#7239EA" : i == 2 ? "#FFC700" : "#165DFF"
                                    }'></span>
                                    <span>{{ item.name }}</span>
                                    <span>{{ item.value + '家' }}</span>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="b_r">
                        <div class="bottom">
                            <div class="server">
                                <div>
                                    <span class="card_">养殖户排行与查询</span>
                                    <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                                </div>
                                <span class="total">共计<i>{{ total }}</i>个</span>
                            </div>
                            <div class="search" style="padding: 0 0.25rem;">
                                <!-- <el-cascader placeholder="所在地域" style="margin-right: 0.2rem; font-size:0.13rem"
                                :props="{ checkStrictly: true }" v-model="address" :options="baseArea">
                            </el-cascader>
                            <el-select v-model="userType" placeholder="养殖户类型"
                                style="margin-right: 0.2rem;font-size:0.13rem">
                                <el-option v-for="item in userTypeList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select> -->
                                <div class="img" style="position: relative;">
                                    <img style="width:.23rem;height:.23rem;position: absolute; top: 0.1rem;left: .1rem;"
                                        src="../../assets/search (1).png" alt="">
                                    <el-input class="search_input" id="myinput" style="width: 4.2rem;" v-model="userName"
                                        @focus="focus" @blur="blur" placeholder="请输入养殖户名称">
                                    </el-input>
                                </div>
                                <div class="btn btn_1" @click="getList">搜索</div>
                                <div class="reset_btn btn_1" @click="reset">重置</div>
                                <div v-if="(this.total > 10)" class="left_ l_f" @click="btnClick('left')"
                                    :class="{ active_2: status === 'left' }">
                                    <span class="el-icon-arrow-left"></span>
                                </div>
                                <div v-if="(this.total > 10)" class="right_ l_f" @click="btnClick('right')"
                                    :class="{ active_2: statusRight === 'right' }">
                                    <span class="el-icon-arrow-right"></span>
                                </div>
                            </div>
                            <dv-scroll-board :config="config" @click="details" @mouseover='mouseover'
                                style="width:11.21rem;height:3.3rem;padding: 0 0.25rem;" />
                            <!-- style="width:17.21rem;height:3.3rem;padding: 0 0.25rem;" -->
                        </div>
                        <div class="right-hot">
                            <div class="server">
                                <div>
                                    <!-- <span class="card_">社会化服务分布</span> -->
                                    <span class="card_">牛羊市场价格趋势</span>
                                    <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                                </div>
                            </div>
                            <div id="hotChart"></div>
                        </div>
                    </div>
                </div>
                <video src="../../assets/66.mp4" muted autoplay="autoplay" loop="loop"></video>
            </div>
            <foldModel v-if='dialogVisible' :dialogVisible='dialogVisible' :showList="showList"
                @close="dialogVisible = false"></foldModel>
            <!-- :dialogVisible='dialogVisible' -->
            <!-- <imgModel @close="dialogVisibleImg = false" :dialogVisibleImg='dialogVisibleImg' /> -->
        </div>
    </Main>
</template>

<script>
import Main from "@/components/main.vue";
import Header from "../../components/shanHeader.vue";
import cityJson from "@/assets/js/city.js";
// import maps from './maps'
import foldModel from './components/foldModel.vue'
// import imgModel from './components/imgModel.vue'


export default {
    components: {
        Main,
        Header,
        foldModel,
        // imgModel
        // XChart
    },
    data() {
        return {
            url: require('../../assets/Aershan1.png'),
            srcList: [
                require('../../assets/Aershan1.png'),
            ],
            chart: null,
            isShowMap: true,
            config: {},
            config1: {},
            baseArea: cityJson,
            timeList: [
                // { value: '2022', label: '2022' },
                { value: '2023', label: '2023' },
                { value: '2024', label: '2024' },
                { value: '2025', label: '2025' },
            ],
            userTypeList: [
                { value: '0', label: '个人牧场' },
                { value: '1', label: '租赁牧场' },
                { value: '2', label: '企业养殖场' },
                { value: '3', label: '合作社' },
                { value: '4', label: '家庭牧场' },
                { value: '5', label: '集体经济养殖户' },
                { value: '6', label: '普通养殖户' },
                { value: '7', label: '国有牧场' },
            ],
            address: [],
            userType: '',
            userName: '',
            headerInfo: {},
            userInfo: {},
            serviceStatus: 'first',
            status: '',
            statusRight: 'right',
            lineData: [],
            // 养殖户列表
            breederList: [],
            //  页码
            pageNum: 1,//第几页
            pageSize: 10,//一页几条
            total: 0,//总数
            // hasPreviousPage: false,//上一页
            // hasNextPage: false,//下一页
            region: {},
            screenData: {},
            dataMap: {}, // 养殖户增长趋势
            data_Map: {},//存储单个养殖户增长趋势
            breedingScaleProp: {}, // 养殖规模分布
            farmerKindDis: [], // 养殖户类型分布
            farmerAreaDis: {},//地图数据
            farmerData: {
                value: '',
                properties: ''
            },
            breeList: [],//存储表格数据
            mapData: [],//地图数据
            goBackShow: false,//上一层
            refreShow: true,
            pages: '',
            // -----------------------
            trend: {},//养殖户增长趋势数据
            trendData: [],//养殖户增长趋势数据(图形)
            barData: {},//养殖规模分布数据
            dialogVisible: false,
            // dialogVisibleImg: false,
            timer: null,
            hotTimer: null,
            // tagTimer: null,
            warnNum: 0,//预警总数
            showList: [],//弹窗列表
            animalTime: '2025',
            liveAnimals: {},//存储活畜总量，牛羊马总量
            livestockCount: [],//活畜总量
            pieData: {
                dom: 'pieChart',
                name: '',
                color: ['#E7C660', '#0EDAE2', '#F7C034'],
                data: [
                    { value: 0, name: '需求量' },//, selected: true
                    { value: 0, name: '购买量' },
                ]
            },
            pieData1: {
                dom: 'hotChart',
                name: '',
                color: ['#00E0DB', '#FFC700', '#7239EA', '#1765ff', '#e7c660'],
                data: [
                    { value: 0, name: '牛结节性皮肤病' },
                    { value: 0, name: '布鲁氏菌病' },
                    { value: 0, name: '口蹄疫(O型抗体ELISA法)' },
                    { value: 0, name: '动物结核病' },
                    { value: 0, name: '口蹄疫(A型抗体ELISA法)' },
                ]
            },
            typeValue: {},//养殖户类型
            imgShow: true,
            forageList: [],//饲草料数据
            animalMarketList: [],//牛羊市场数据
        };
    },
    watch: {},
    // 销毁定时器
    destroyed() {
        clearInterval(this.timer)
        clearInterval(this.hotTimer)
        // clearInterval(this.tagTimer)
    },
    created() {
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        // this.address = JSON.parse(window.localStorage.getItem('ADDRESS'));
        this.getBreederList()
        this.baseArea = this.baseArea.filter(item => {
            return item.label == '内蒙古自治区'
        })
        // ------------------------------
        //获取养殖户增长趋势
        this.timeChange(this.animalTime)
        //获取养殖户区域分布
        this.farmerArea()
        //获取养殖规模分布
        this.getBarData()
        // 获取养殖户类型分布
        this.getPieData()
        // 获取近七日
        this.getDays()
        //获取饲草料数据
        // this.forageData()
        //获取防疫占比数据
        // this.getEpidemicProp()
        //获取社会化服务数据
        // this.serviceOrderNumData()
        // -- 保存预警信息
        this.getTag()
        // 获取预警总数
        // this.getWarnNum()
    },
    mounted() {
        // this.getData()
        // this.draws(maps)
        // 实时刷新
        this.getChange()
    },
    methods: {
        imgPop() {
            // this.dialogVisibleImg = true
            this.$refs.previewImg.showViewer = true;
            const m = (e) => { e.preventDefault() };
            document.body.style.overflow = 'hidden';
            document.addEventListener("touchmove", m, false); // 禁止页面滑动
        },
        closeImgViewer() {
            // this.dialogVisibleImg = false;
            const m = (e) => { e.preventDefault() };
            document.body.style.overflow = 'auto';
            document.removeEventListener("touchmove", m, true);
        },
        // 鼠标滚轮事件
        onMouseWheel(ev) {
            console.log(1111);
            var svgId = document.getElementById("svgId");
            var down = true; // 定义一个标志，当滚轮向下滚时，执行一些操作
            down = ev.wheelDelta < 0 || ev.detail > 0 ? true : false;

            if (down) {
                if (this.scal >= 2) {
                    this.scal = 2;
                    svgId.style.transform = "scale(" + this.scal + ")";
                    //svgId.style.transformOrigin = "0 0";
                    return;
                } else {
                    this.scal += 0.1;
                    //console.log("放大系数: " + this.scal);
                    if (this.scal <= 2 && this.scal >= 0.3)
                        svgId.style.transform = "scale(" + this.scal + ")"; //scale()在这里要使用拼接                                                                                                                                                                    
                    //的方式才能生效
                }
            } else {
                if (this.scal <= 0.3) {
                    this.scal = 0.3;
                    svgId.style.transform = "scale(" + this.scal + ")";
                    return;
                } else {
                    this.scal -= 0.1; // (parseFloat(this.scal) - 0.1).toFixed(2);
                }
                //console.log("缩小系数: " + this.scal);
                svgId.style.transform = "scale(" + this.scal + ")";
                //svgId.style.transformOrigin = "0 0";
            }
            // if (ev.preventDefault) {
            //   /*FF 和 Chrome*/
            //   ev.preventDefault(); // 阻止默认事件
            // }
            // return false;
        },
        // 下拉选择
        timeChange(val) {
            this.getTrendData(val)
        },
        // 实时刷新
        getChange() {
            this.timer = setInterval(() => {
                //获取养殖户增长趋势
                this.timeChange(this.animalTime)
                //获取养殖户区域分布
                this.farmerArea()
                //获取养殖规模分布
                this.getBarData()
                // 获取养殖户类型分布
                this.getPieData()
                // 获取近七日
                this.getDays()
                //获取饲草料数据
                // this.forageData()
                //获取防疫占比数据
                // this.getEpidemicProp()
                // 获取预警总数
                // this.getWarnNum()
            }, 5000)
            this.hotTimer = setInterval(() => {
                //获取预警信息
                this.getTag()
                // 养殖户列表
                this.getBreederList()
            }, 1000 * 1200)
        },
        getInfoList() {
            console.log(111);
            this.$http({
                url: 'screenapp-service/screenWarningInfo/listAll',
                //请求方式
                method: 'post',
                //传递的参数
                data: {

                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.showList = []
                    data.result.forEach((v) => {
                        for (var key in v) {
                            if (!v[key]) {
                                v[key] = '-'
                            }
                        }
                        this.showList.push(
                            [v.farmerName, v.phone, v.address, v.earTag, v.typeName, v.varietiesName, v.monthAge, v.step, v.temperature, v.warningDate]
                        )
                    })
                } else {
                    // this.$message.error(data);
                }
            })
        },
        // 近七日
        getDays() {
            this.$http({
                url: 'screenapp-service/aErShan/seven/days',
                //请求方式
                method: 'get',
                //传递的参数
                data: {

                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    // 获取饲草料
                    this.getOfflineList(data.result)
                    // 获取牛羊价格趋势
                    this.animalPriceList(data.result)
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getOfflineList(val) {
            this.$http({
                url: 'screenapp-service/aErShan/trend/data',
                //请求方式
                method: 'get',
                //传递的参数
                data: {

                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.forageList = []
                    const type = [
                        {
                            name: '犊牛料',
                            value: 'duniuliao'
                        },
                        {
                            name: '羔羊料',
                            value: 'gaoyangliao'
                        },
                        {
                            name: '过冬料',
                            value: 'guodongliao'
                        },
                        {
                            name: '母牛料',
                            value: 'muniuliao'
                        },
                        {
                            name: '母羊料',
                            value: 'muyangliao'
                        },
                    ]
                    for (var key in data.result) {
                        type.forEach((item) => {
                            if (key == item.value) {
                                this.forageList.push({
                                    title: item.name, value: data.result[key], month: val
                                })
                            }
                        })

                    }
                    this.setLineData(this.forageList, 'pieChart')
                } else {
                    // this.$message.error(data);
                }
            })
        },
        animalPriceList(val) {
            this.$http({
                url: 'screenapp-service/aErShan/price/float',
                //请求方式
                method: 'get',
                //传递的参数
                data: {

                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.animalMarketList = []
                    const type = [
                        {
                            name: '牛',
                            value: 'cow'
                        },
                        {
                            name: '羊',
                            value: 'sheep'
                        },
                    ]
                    for (var key in data.result) {
                        type.forEach((item) => {
                            if (key == item.value) {
                                this.animalMarketList.push({
                                    title: item.name, value: data.result[key], month: val
                                })
                            }
                        })

                    }
                    this.animalMarketList.forEach((item) => {
                        if (item.title == '羊') {
                            item.value[item.value.length - 1] = '60.00'
                        }
                    })
                    this.setLineData(this.animalMarketList, 'hotChart')
                } else {
                    // this.$message.error(data);
                }
            })
        },
        // -- 保存预警信息
        getTag() {
            this.$http({
                url: 'screenapp-service/aErShanWarningInfo/tag',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "addressTag": 1
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getWarnNum() {
            this.$http({
                url: 'screenapp-service/aErShanWarningInfo/count',
                //请求方式
                method: 'post',
                //传递的参数
                data: {

                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.warnNum = data.result
                } else {
                    // this.$message.error(data);
                }
            })
        },
        //获取防疫占比数据
        getEpidemicProp() {
            this.$http({
                url: 'screenapp-service/aErShan/countactiveprop',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "activeType": 6
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    if (Object.keys(data.result).length == 0) {
                        this.pieChart(this.pieData1)
                        return
                    }

                    this.pieData1.data = []
                    for (var key in data.result) {
                        this.pieData1.data.push({ name: key, value: data.result[key] })
                    }
                } else {
                    // this.$message.error(data);
                }
                this.pieChart(this.pieData1)

            })
        },
        //获取养殖户区域分布
        farmerArea() {
            this.$http({
                url: 'screenapp-service/aErShan/selectPastureBreedingCount',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.liveAnimals = data.result
                    this.livestockCount = (this.liveAnimals.livestockCount && String(this.liveAnimals.livestockCount).split('')) || [0]
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getTrendData(val) {
            this.$http({
                url: 'screenapp-service/aErShan/growingTrend',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "year": val,
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    // console.log(data.result, '2');
                    this.trend = {}
                    this.trendData = []
                    this.trend = data.result
                    let cow1 = []
                    let cow2 = []
                    let sheep1 = []
                    let sheep2 = []
                    let horse1 = []
                    let horse2 = []
                    let months = []
                    data.result.listMap.cow.forEach((item) => {
                        cow1.push(item.outNum)
                        cow2.push(item.inNumber)
                        if (item.month < 10) {
                            item.month = 0 + item.month
                        }
                        months.push(val.split('').splice(2, 2).join('') + '-' + item.month)
                    })
                    data.result.listMap.sheep.forEach((item) => {
                        sheep1.push(item.outNum)
                        sheep2.push(item.inNumber)
                    })
                    data.result.listMap.horse.forEach((item) => {
                        horse1.push(item.outNum)
                        horse2.push(item.inNumber)
                    })
                    this.trendData.push({ title: '牛出栏', value: cow1, month: months },
                        { title: '牛入栏', value: cow2, month: months },
                        { title: '羊出栏', value: sheep1, month: months },
                        { title: '羊入栏', value: sheep2, month: months },
                        { title: '马出栏', value: horse1, month: months },
                        { title: '马入栏', value: horse2, month: months },
                    )
                    this.setLineData(this.trendData, 'lineChart')
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getBarData() {
            this.$http({
                url: 'screenapp-service/aErShan/listPastureBreedingList',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.barData = {}
                    // this.barData['label'] = Object.keys(data.result)
                    // this.barData['value'] = Object.values(data.result)
                    this.barData['label'] = []
                    this.barData['value'] = []
                    var arr = ['0-10头', '10-50头', '50-100头', '100-300头', '300-500头', '500头以上']
                    arr.forEach((item, i) => {
                        for (var key in data.result) {
                            if (item == key) {
                                this.barData['label'][i] = key
                                this.barData['value'][i] = data.result[key]
                            }
                        }
                    })
                    this.setBarData(this.barData)
                } else {
                    this.barData['label'] = ['0-10头', '10-50头', '50-100头', '100-300头', '300-500头', '500头以上']
                    this.barData['value'] = [0, 0, 0, 0, 0, 0]
                    this.setBarData(this.barData)
                    // this.$message.error(data);
                }
            })
        },
        getPieData() {
            this.$http({
                url: 'screenapp-service/aErShan/farmerKinds',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    "address": "阿尔善",
                    "name": "",
                    "farmerTypeCode": "",
                    "pageNum": 1,
                    "pageSize": 5000,
                    "dataFlag": 1
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.typeValue = data.result
                    // this.farmerKindDis = []
                    // for (var key in data.result) {
                    //     this.farmerKindDis.push({ name: key, value: data.result[key] })
                    // }
                    // this.config1 = {
                    //     data: this.farmerKindDis,
                    //     color: ['#3AFFFB', '#7239EA', '#FFC700', '#165DFF', '#469f4b'],
                    //     radius: '65%',
                    //     activeRadius: '70%',
                    //     lineWidth: 35,
                    //     digitalFlopStyle: {
                    //         fontSize: 20
                    //     },
                    //     activeTimeGap: 2000,
                    // }
                } else {
                    // this.$message.error(data);
                }
            })
        },
        forageData() {
            this.$http({
                url: 'screenapp-service/aErShan/forage',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "address": "阿尔善"
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.pieData.data[0].value = Number(data.result.requireQty)
                    this.pieData.data[1].value = Number(data.result.buyQty)
                } else {
                    // this.$message.error(data);
                }
                this.pieChart(this.pieData)
            })
        },
        serviceOrderNumData() {
            this.$http({
                url: 'screenapp-service/aErShan/serviceOrderNum',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.pieData1.data[0].value = Number(data.result.serviceCount)
                    this.pieData1.data[1].value = Number(data.result.buyCount)
                } else {
                    // this.$message.error(data);
                }
                this.pieChart(this.pieData1)
            })
        },
        // ------------------------------
        showWatch() {
            this.dialogVisible = true
        },
        // 养殖户排行鼠标移入全部显示
        mouseover() {
            var divs = [...document.querySelectorAll('.b_r .row-item')]
            divs = [...divs]
            divs.forEach(item => {
                item.childNodes.forEach(it => {
                    (it.clientWidth < it.scrollWidth ? (it.title = it.innerText) : 'return')
                })
            })
        },
        focus() {
            var val = document.querySelector('#myinput')
            val['placeholder'] = ''

        },
        blur() {
            var val = document.querySelector('#myinput')
            val['placeholder'] = '请输入养殖户名称'
        },
        // 返回上一层
        goBack() {
            this.goBackShow = false
            this.refreShow = false
            this.$nextTick(() => {
                this.refreShow = true
                // this.getData()
            })
            // this.$router.go(0)
        },
        // 跳转养殖户详情
        details(val) {
            // console.log(this.breeList[val.rowIndex]);
            window.localStorage.setItem('MYINFO2', JSON.stringify(this.breeList[val.rowIndex]))
            this.$router.push({ name: 'details2' })
        },
        serviceStatusBtn(val) {
            if (val === 'first') {
                this.serviceStatus = 'first'
                this.data_Map = this.dataMap.oneMonth
            }
            if (val === 'three') {
                this.serviceStatus = 'three'
                this.data_Map = this.dataMap.threeMonth
            }
            if (val === 'six') {
                this.serviceStatus = 'six'
                this.data_Map = this.dataMap.sixMonth
            }
            this.lineData = []
            this.lineData.push({ name: '养殖户家数', value: this.data_Map.value, month: this.data_Map.label })
            this.setLineData(this.lineData, 'lineChart')
        },
        // 重置
        reset() {
            this.address = JSON.parse(window.localStorage.getItem('ADDRESS'));
            this.userType = '';
            this.userName = '';
            this.status = ''
            this.statusRight = 'right'
            this.pageNum = 1
            this.getBreederList()
        },
        // 翻页
        btnClick(val) {
            // if (val === 'left') {
            //     if (this.hasPreviousPage) {
            //         this.status = 'left'
            //         if(this.pageNum>1)  this.pageNum--
            //         this.getBreederList()
            //     } else {
            //         this.status = 'right'
            //     }
            // }
            if (val === 'left') {
                if (this.pageNum > 1) {
                    this.status = 'left'
                    this.statusRight = 'right'
                    // if (this.pageNum > 1)
                    this.pageNum--
                    this.pageNum == 1 ? this.status = '' : this.status = 'left'
                    this.getBreederList()
                } else {
                    this.status = ''
                }
            }
            if (val === 'right') {
                if (this.pageNum < this.pages) {
                    this.status = 'left'
                    this.statusRight = 'right'
                    // if(this.pageNum<Math.floor(this.total/this.pageSize))
                    this.pageNum++
                    this.pageNum == this.pages ? this.statusRight = '' : this.statusRight = 'right'
                    this.getBreederList()
                } else {
                    this.statusRight = ''
                }
            }
        },
        // 设置折线图
        setLineData(data, dom) {
            const colors = ['#2C76FE', '#00E0DB', '#F7BA1E', '#7239EA', '#5672FA', '#04FF00'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#FFFFFF' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.month
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                legend: {
                    data: legend,
                    // x: 'right',
                    y: 'bottom',
                    // top: "0%",
                    // right: "3%",
                    // bottom:'10%',
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [20, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            var linechart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    formatter: (params) => {
                        // console.log(params, 'params');
                        // return `<p>
                        //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                        //     }： ${params.data.account || 0} </span>

                        //       </p>`;
                        if (data.dom == 'lineChart') {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                                }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">牛出栏：${params[0].value}头</p>
                        <p style="font-size: 14px; font-weight: normal;">牛入栏：${params[1].value}头</p>
                        <p style="font-size: 14px; font-weight: normal;">羊出栏：${params[2].value}只</p>
                        <p style="font-size: 14px; font-weight: normal;">羊入栏：${params[3].value}只</p>
                        <p style="font-size: 14px; font-weight: normal;">马出栏：${params[4].value}匹</p>
                        <p style="font-size: 14px; font-weight: normal;">马入栏：${params[5].value}匹</p>
                         `;
                        }
                        if (data.dom == 'pieChart') {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                                }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].seriesName}：${params[0].value}元/吨</p>
                        <p style="font-size: 14px; font-weight: normal;">${params[1].seriesName}：${params[1].value}元/吨</p>
                        <p style="font-size: 14px; font-weight: normal;">${params[2].seriesName}：${params[2].value}元/吨</p>
                        <p style="font-size: 14px; font-weight: normal;">${params[3].seriesName}：${params[3].value}元/吨</p>
                        <p style="font-size: 14px; font-weight: normal;">${params[4].seriesName}：${params[4].value}元/吨</p>
                         `;
                        }
                        if (data.dom == 'hotChart') {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                                }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].seriesName}：${params[0].value}元/kg</p>
                        <p style="font-size: 14px; font-weight: normal;">${params[1].seriesName}：${params[1].value}元/kg</p>
                         `;
                        }
                        // return params.name
                    },
                    padding: [5, 30],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '20%',
                    left: '5%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: data.dom == 'lineChart' ? '数量' : data.dom == 'pieChart' ? '元/吨' : '元/kg',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 40, 0, 0],
                        lineHeight: 45,
                        // align:'left'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 4,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            linechart.clear();
            linechart.setOption(option)
            window.addEventListener('resize', () => {
                linechart.resize()
            })
        },
        // 牛羊只存栏柱状图
        setBarData(data) {
            var barchart = this.$echarts.init(document.getElementById('barChart'))
            // 隐藏动画加载效果。
            var option = {
                title: {
                    text: '',
                    textAlign: 'left',
                    textStyle: {
                        color: '#00DAC8', // 主标题文字的颜色。
                        fontSize: 18, // 字体大小
                        lineHeight: '30', // 行高
                    },
                    triggerEvent: false, // 是否触发事件
                    x: 'center',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    formatter: function (params) {
                        // console.log(params,'params');
                        return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                            }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].value + '家'
                            }</p>
                         `;
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: '',
                grid: {
                    top: '20%',
                    // 20
                    left: '3%',
                    right: '4%',
                    bottom: '1%',
                    // height: '150px',
                    // 130
                    // 150
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                        rotate: 30,
                        // interval: 'auto',
                        textStyle: {
                            fontSize: 12
                        },
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true,
                        // interval: 0,
                        // alignWithLabel:1,
                        lineStyle: {
                            dashOffset: 5
                        },
                        // length:10
                    },
                    data: data.label,
                },
                yAxis: {
                    name: '养殖户家数',
                    // name:this.cattleStatus=="cattle"?'数量(头)':'数量',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 4],
                        lineHeight: 45,
                    },
                    type: 'value',
                    splitNumber: 4,
                    minInterval: 1,//自动计算的坐标轴最小间隔大小。例如可以设置成1保证坐标轴分割刻度显示成整数。
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisTick: { show: false },

                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: '#6FB6FF',
                        },
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                        textStyle: {
                            fontSize: 12
                        }
                    },
                },
                series: {
                    // name: barData.name,
                    type: 'bar',
                    barWidth: '15',
                    barGap: 0,
                    emphasis: {
                        focus: "series",
                    },
                    backgroundStyle: {
                        // color: 'rgba(44, 118, 254, 0.2)'
                        color: '#00E0DB'
                    },
                    itemStyle: {
                        // opacity: 0.8,
                        // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //     {
                        //         offset: 1,
                        //         color: "#297DFC",
                        //     },
                        //     {
                        //         offset: 0,
                        //         color: "#06FDF5",
                        //     },
                        // ]),
                        color: "#00E0DB"
                    },
                    data: data.value,
                },
            }
            barchart.clear();
            barchart.setOption(option)
            window.addEventListener('resize', () => {
                barchart.resize()
            })
        },
        // 自定义饼图图例
        getFormatter(name, data) {
            // console.log(data);
            let arr = []
            let count
            let sum = 0
            data.forEach((item) => {
                sum += item.value
                return sum
            })
            for (const item of data) {
                if (item.name == name) {
                    count = `${(item.value / sum * 100).toFixed(2)}%`
                }
            }
            if (sum == 0) {
                count = `0%`
            }
            arr = [name, count]
            return arr.join('  ')
        },
        pieChart(data) {
            var myChart = this.$echarts.init(document.getElementById(data.dom));
            var option = {
                color: data.color,
                grid: {
                    top: '20%',
                    left: '10%',
                    // height: '60px',
                },
                legend: {
                    show: data.dom == 'hotChart' ? false : true,
                    icon: "circle",
                    bottom: "0%",
                    left: "center",
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 50,
                    padding: [10, 0, 0, 0],
                    textStyle: { color: '#00E0DB' },
                    formatter: (name) => {
                        // console.log(name)
                        return this.getFormatter(name, data.data)
                    },
                },
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    padding: 5,
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 2)
                        return `
                        <p>
                          <span style="font-size: 14px; font-weight: normal;">${params.data.name}${(params.data.name == '需求量' || params.data.name == '购买量') ? `(吨)` : ''}： ${params.data.value || 0} </span>
                        </p><br/> 
                         `;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#FFFFFF',
                            // formatter: ' {b} {d}% \n\n',
                            formatter: function (params) {
                                if (params.percent === undefined) {
                                    return params.name + 0 + '% \n\n'
                                } else if (params.percent === 0) {
                                    return params.name + params.percent + '% \n\n'
                                } else {
                                    return params.name + params.percent + '% \n\n'
                                }
                            },
                            padding: [0, -60],
                            alignTo: 'labelLine'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                // fontSize: '40',
                                // fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true,
                            length: 5,
                            length2: 60,
                            lineStyle: {
                                color: '#73c0de',
                            }
                        },
                        data: data.data
                    }
                ]
            };
            myChart.clear();
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        // 搜索
        getList() {
            this.pageNum = 1
            this.status = ''
            this.statusRight = 'right'
            this.getBreederList()
        },
        // 获取养殖户列表
        getBreederList() {
            // let provinceId = ''
            // let countId = ''
            // let cityId = ''
            // if (this.address.length > 0) {
            //     provinceId = this.address[0]
            //     cityId = this.address[1] ? this.address[1] : ''
            //     countId = this.address[2] ? this.address[2] : ''
            // }
            this.$http({
                url: 'screenapp-service/baseScreenFarmer/farmerList/aErShan',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    // provinceId: provinceId,
                    // countyId: countId,
                    // cityId: cityId,
                    // countId: '152502',
                    address: '阿尔善',
                    name: this.userName,
                    farmerTypeCode: this.userType,
                    pageNum: this.pageNum,//第几页
                    pageSize: this.pageSize,//一页几条
                    "dataFlag": 1,
                },
            }).then(res => {
                this.breederList = []
                res.data.result.list.forEach((item, i) => {
                    for (var key in item) {
                        if (!item[key]) {
                            item[key] = '—'
                        }
                    }
                    if (item.breedingMethod == '0') {
                        item.breedingMethod = '圈养'
                    }
                    if (item.breedingMethod == '1') {
                        item.breedingMethod = '半圈养'
                    }
                    if (item.breedingMethod == '2') {
                        item.breedingMethod = '散养'
                    }
                    this.breederList.push([i + 1, item.farmerName, item.farmerType, item.address, item.breedingNum, `<span style="border: 0.01rem solid rgba(0,117,126,0.3);padding:.05rem .1rem;color:#00D7D3;cursor:pointer;background: rgba(255, 255, 255, 0.1);">查看</span>`])
                })
                this.config = {
                    header: ['排序', '名称', '养殖户类型', '所在地域', '养殖数量(头)', ''],//, '所属畜牧科技师' item.rearLiveStock,
                    data: this.breederList,
                    align: ['center', 'left', 'left', 'left', 'right', 'center'],
                    // columnWidth: [160, 180, 180, 320, 180, 180, 160],
                    headerHeight: 40,
                    waitTime: 2000
                }
                this.breeList = res.data.result.list
                this.total = res.data.result.total
                this.pages = res.data.result.pages
                // this.hasPreviousPage = res.data.result.hasPreviousPage,//上一页
                //     this.hasNextPage = res.data.result.hasNextPage//下一页
            }).catch(() => {
                this.config = { header: ['排序', '名称', '养殖户类型', '所在地域', '所属畜牧科技师', '养殖数量(头)', ''], data: [] }
                this.total = 0
            })
        },
        getData() {
            this.$http({
                url: 'screenapp-service/baseBigScreen/select/other',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "parentId": "4",
                    "menuMark": "3",
                    "dataFlag": "0",
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    const screenData = JSON.parse(data.result.screenData)
                    this.headerInfo = { name: data.result.screenName }
                    this.dataMap = screenData.farmerGrowTrend.dataMap
                    this.data_Map = screenData.farmerGrowTrend.dataMap.oneMonth//默认显示一月
                    this.lineData = []
                    this.lineData.push({ name: '养殖户家数', value: this.data_Map.value, month: this.data_Map.label }),
                        this.breedingScaleProp = screenData.breedingScaleProp
                    // this.farmerKindDis = screenData.farmerKindDis
                    this.farmerAreaDis = screenData.farmerAreaDis
                    this.mapData = this.farmerAreaDis.map
                    this.farmerData = {
                        value: this.farmerAreaDis.account,
                        properties: this.farmerAreaDis.proportion
                    }
                    // this.flopData()
                    // this.farmerAreaDis.map.forEach(item => {
                    //     item.name = item.city
                    //     item.value = item.account
                    // })
                    // this.farmerKindDis = this.farmerKindDis.map(item => {
                    //     item.value = +item.proportion
                    //     item.name = item.title
                    //     return item
                    // })
                    // this.config1 = {
                    //     data: this.farmerKindDis,
                    //     color: ['#3AFFFB', '#7239EA', '#FFC700', '#165DFF', '#469f4b'],
                    //     radius: '65%',
                    //     activeRadius: '70%',
                    //     lineWidth: 35,
                    //     digitalFlopStyle: {
                    //         fontSize: 20
                    //     },
                    //     activeTimeGap: 2000,
                    //     // digitalFlopToFixed:2
                    //     // showOriginValue:true
                    // }
                    // this.setLineData(this.lineData, 'lineChart')
                    // this.setBarData(this.breedingScaleProp)
                    // this.getMap()
                } else {
                    this.$message.error(data);
                }
            })
        },
        // 正蓝旗
        draws(geoJson, data) {
            // 基于准备好的dom，初始化echarts实例
            this.chart = this.$echarts.init(document.getElementById("mapBox"));
            // bayannaoer
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();
            var option = {
                grid: {
                    // top: '30%',
                    // height: "400px",
                    // containLabel: true,
                },
                select: {
                    disabled: true,
                    itemStyle: {
                        areaColor: "#1E88E5",
                        borderColor: "#21bde6",
                        borderWidth: "1"
                    },
                    label: {
                        show: false,
                        color: '#fff',
                        position: 'top'
                    },
                },
                blur: {
                    itemStyle: {
                        areaColor: "#1E88E5",
                        borderColor: "#21bde6",
                        borderWidth: "1"
                    }
                },
                tooltip: {
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00E0DB;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                        //         <p>
                        //  <span style="color: #FFF; font-size: 14px; font-weight: normal;">${params.data.code == "养殖户分布" ? '养殖户数量' : '活畜数量'}<span style="color: #00E0DB; font-size: 16px;">${params.data.value || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">${params.data.code == "养殖户分布" ? "家" : '头'}</span> </span>
                        //         </p>
                    },
                },
                series: [
                    {
                        type: "map", // 系列类型
                        name: "map", // 系列名称
                        zoom: 1,
                        // roam: true,
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data ? data : [],
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: true, // (地图上的城市名称)是否显示标签 [ default: false ]
                            distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 18, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#0f3a67',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                            normal: { // 默认地图区域样式
                                // areaColor: 'rgba(33,80,231,1)',
                                areaColor: "#0f3a67",
                                // borderColor: "#4ECEE6",
                                borderColor: "#165d7d",
                                borderWidth: 1,
                                // shadowColor: "#2C99F6",
                                // shadowOffsetY: 0,
                                // shadowBlur: 25,
                            },
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: true,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 18, // 高亮时标签字体 变大
                                },
                                // formatter: function (params) {
                                //   // console.log(params)
                                //   return params.name
                                // }
                            },
                            itemStyle: {
                                "areaColor": "#1E88E5"
                            }
                        }
                    },
                ],
            }
            this.chart.clear();
            this.chart.setOption(option);
            // chart.on('click', (ret) => {
            //     console.log(ret,'wodianle');
            // })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        flopData() {
            var reg = new RegExp('%', 'g')
            this.farmerData.properties = Number(this.farmerData.properties.replace(reg, ''))
        }
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        position: relative;

        .gobcak {
            width: .875rem;
            height: .4375rem;
            position: absolute;
            z-index: 99;
            bottom: -0.22rem;
            left: 0.25rem;
            font-size: .2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: .3rem;
                height: .3rem;
            }

            span {
                margin-left: .05rem;
            }
        }
    }

    .content {
        position: relative;
        padding: .25rem;
        box-sizing: border-box;
        display: flex;
        min-height: 12.5rem;
        // min-height: calc(100vh - 1rem);

        // background: url('../../assets/bg-hhr.png');
        // background-size: 100% 100%;


        video {
            position: absolute;
            top: -0.5rem;
            left: 0;
            z-index: -1;
            width: 100%;
            height: 100%;
        }

        .left {
            width: 6rem;

            .l_t {
                height: 6.85rem;
                background: linear-gradient(180deg, rgba(0, 241, 238, 0.1) 0%, rgba(0, 223, 218, 0) 100%);

                .amount {
                    position: relative;
                    display: flex;
                    // justify-content: space-between;
                }

                .amountOne {
                    margin-top: .25rem;
                    margin-left: .25rem;
                }

                .add_total {
                    display: flex;
                    margin-top: .4rem;
                    margin-left: .3rem;

                    .add_item {
                        display: flex;
                        flex-direction: column;
                        margin-right: 0.2rem;

                        div {
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                            line-height: 0.18rem;
                            padding-top: .1rem;

                            span:nth-child(2) {
                                margin-left: .54rem;
                                font-size: 0.15rem;
                                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                                font-weight: 500;
                                color: #FF5A0D;
                                line-height: 0.18rem;

                                i {
                                    font-style: normal;
                                }
                            }

                            img {
                                margin-left: .1rem !important;
                            }
                        }

                        .num {
                            display: block;
                            font-size: 0.25rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: 700;
                            color: #00E0DB;
                            // line-height: 0.38rem;
                            // padding-top: .11rem;
                            // padding-left: .08rem;
                        }

                        div {
                            min-width: 2rem;
                        }

                    }
                }

                .hand {
                    font-size: 0.25rem;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #FFFFFF;
                }

                ul {
                    margin-top: .15rem;
                    display: flex;

                    li {
                        width: 0.56rem;
                        height: 0.63rem;
                        background: rgba(0, 224, 219, 0.05);
                        box-shadow: inset 0rem 0rem 0.08rem 0rem rgba(0, 224, 219, 0.2);
                        opacity: 1;
                        border: 0.01rem solid rgba(0, 224, 219, 0.1);
                        font-size: 0.45rem;
                        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                        font-weight: bold;
                        color: #00E0DB;
                        line-height: .63rem;
                        text-align: center;
                        margin-right: .14rem;
                    }
                }

                .line_chart {
                    width: 100%;
                    // height: 4.5rem;
                    height: 3.8rem;
                    margin-top: .2rem;
                }
            }

            .l_b {
                height: 4.9rem;
                background: linear-gradient(180deg, rgba(0, 223, 218, 0) 0%, rgba(0, 241, 238, 0.1) 100%);
                margin-top: .25rem;



                .bar_chart {
                    width: 100%;
                    height: 3.7rem;
                    margin-top: 0.7rem;
                }
            }
        }

        .right {
            width: 17.21rem;
            margin-left: .25rem;

            .top {
                display: flex;

                .map_box {
                    width: 11.23rem;
                    height: 6.85rem;
                    background: linear-gradient(180deg, rgba(0, 241, 238, 0.1) 0%, rgba(0, 223, 218, 0) 100%);

                    .center {
                        display: flex;
                        justify-content: space-around;
                        margin-top: .4rem;
                        // margin-left: .86rem;

                        .text_n {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            font-size: 0.2rem;
                            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                            font-weight: 400;
                            // color: #00E0DB;
                            color: #FFFFFF;
                            cursor: pointer;

                            span:nth-child(1) {
                                font-size: 0.2rem;
                                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                                font-weight: 500;
                                color: #00E0DB;
                                // margin-top: .19rem;
                            }

                            span:nth-child(2) {
                                font-size: 0.3rem;
                                font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
                                font-weight: 900;
                                color: #FFE11D;
                                margin-top: .2rem;
                            }
                        }
                    }

                    #mapBox {
                        display: flex;
                        justify-content: center;
                        width: 100%;
                        height: 5.4rem;

                        .AershanImg {
                            margin-top: .5rem;
                            width: 50%;
                            height: 4.8rem;
                            cursor: pointer;
                        }

                        img {
                            margin-top: .5rem;
                            width: 50%;
                            height: 4.8rem;
                            cursor: pointer;
                        }

                        // margin-top: .5rem; 
                    }
                }

                .ranght {
                    width: 5.74rem;
                    height: 6.85rem;
                    background: linear-gradient(180deg, rgba(0, 241, 238, 0.1) 0%, rgba(0, 223, 218, 0) 100%);
                    margin-left: .25rem;


                    #pieChart {
                        width: 100%;
                        // height: 3.7rem;
                        // margin-top: 1.35rem;
                        height: 4.7rem;
                        margin-top: 0.35rem;
                        cursor: pointer;
                    }

                    .lenged {
                        width: 80%;
                        height: 1rem;
                        display: flex;
                        align-items: center;
                        justify-content: space-evenly;
                        flex-wrap: wrap;
                        margin-left: 1.2rem;

                        div {
                            width: 50%;
                            cursor: pointer;

                            span:nth-child(1) {
                                display: inline-block;
                                width: .09rem;
                                height: .09rem;
                                border-radius: 50%;
                                // background-color: red;
                            }

                            span:nth-child(2),
                            span:nth-child(3) {
                                font-size: 0.15rem;
                                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                                font-weight: 400;
                                color: #00E0DB;
                                margin-left: .13rem;
                            }
                        }
                    }
                }
            }

            .b_r {
                display: flex;
                height: 4.9rem;
                margin-top: .25rem;

                .bottom {
                    // width: 11.23rem;
                    // height: 4.9rem;
                    // margin-top: .25rem;
                    background: linear-gradient(180deg, rgba(0, 223, 218, 0) 0%, rgba(0, 241, 238, 0.1) 100%);

                    .total {
                        font-size: 0.2rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #00E0DB;
                        margin-right: .68rem;

                        i {
                            font-style: normal;
                            color: #FFE11D;
                            font-size: .3rem;
                            padding: 0 .2rem;
                        }
                    }

                    .search {
                        height: .48rem;
                        margin: .19rem 0 .15rem 0;
                        display: flex;
                        align-items: center;
                        position: relative;

                        .btn_1 {
                            font-size: 0.15rem;
                            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                            font-weight: 400;
                            color: #00E0DB;
                            text-align: center;
                            line-height: .48rem;
                            cursor: pointer;
                        }

                        .btn {
                            width: 1.09rem;
                            background: url('../../assets/search\ \(2\).png');
                            background-size: 100% 100%;
                            margin-left: 0.2rem;
                        }

                        .reset_btn {
                            width: 1.09rem;
                            background: url('../../assets/search\ \(3\).png');
                            background-size: 100% 100%;
                            margin-left: 0.2rem;
                        }

                        .left_ {
                            margin-left: 3rem;
                            margin-right: .14rem;
                        }


                        .l_f {
                            width: 0.44rem;
                            height: 0.44rem;
                            background: rgba(255, 255, 255, 0.05);
                            border-radius: 0.08rem;
                            text-align: center;
                            line-height: .44rem;
                            cursor: pointer;
                            color: #7B8A8A;

                            span {
                                width: 0.1rem;
                                height: 0.17rem;
                                font-weight: 700;
                            }

                        }
                    }
                }

                .right-hot {
                    width: 5.74rem;
                    margin-left: .25rem;
                    background: linear-gradient(180deg, rgba(0, 223, 218, 0) 0%, rgba(0, 241, 238, 0.1) 100%);

                    #hotChart {
                        width: 100%;
                        height: 3.7rem;
                        margin-top: 0.4rem;
                    }
                }
            }
        }
    }

    .server {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.48rem;
        background: linear-gradient(119deg, rgba(0, 222, 217, 0.2) 19%, rgba(0, 223, 218, 0) 88%);

        // padding-top: .24rem;
        .card_ {
            font-size: 0.23rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #00E0DB;
            padding-left: .25rem;
        }

        .date {
            // margin-left: 1.2rem;
            color: #00E0DB;
            padding-right: 0.15rem;

            span {
                padding: .05rem;
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                background: rgba(255, 255, 255, 0.05);
                opacity: .5;
                font-weight: 400;
                cursor: pointer;
            }

            span:nth-child(2) {
                margin: 0 .13rem;
            }
        }
    }

    .active {
        opacity: 1 !important;
    }

    .active_2 {
        background: rgba(255, 255, 255, 0.2) !important;
        opacity: 1;
        color: #00E0DB !important;
    }

    //下拉
    .el-select {
        width: 1.5rem;
        height: 0.38rem;
        line-height: .38rem;
        background: rgba(0, 223, 218, 0.0588);
        border-radius: 0rem 0rem 0rem 0rem;
        opacity: 1;
        border: 0.01rem solid rgba(0, 223, 218, 0.4);
        // margin-top: .2rem;
        float: right;

        .el-input__inner {
            // width: 2.79rem;
            height: 0.38rem;
            line-height: .38rem;
            color: #00E0DB !important;
            font-size: .13rem !important;
        }
    }

    .add {
        position: absolute;
        top: 0.4rem;
        left: 1.5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 2.9rem;
        // margin-left: -0.2rem;

        .add_item {
            // height: .4rem;
            font-size: 0.18rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: .25rem;

            span:nth-child(2) {
                font-weight: 700;
                color: #00E0DB;
            }
        }

        // .add_item {
        //     display: flex;
        //     flex-direction: column;
        //     margin-right: 0.2rem;

        //     div {
        //         font-size: 0.15rem;
        //         font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        //         font-weight: 400;
        //         color: #FFFFFF;
        //         line-height: 0.18rem;
        //         padding-top: .1rem;

        //         span:nth-child(2) {
        //             margin-left: .54rem;
        //             font-size: 0.15rem;
        //             font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        //             font-weight: 500;
        //             color: #FF5A0D;
        //             line-height: 0.18rem;

        //             i {
        //                 font-style: normal;
        //             }
        //         }

        //         img {
        //             margin-left: .1rem !important;
        //         }
        //     }

        //     .num {
        //         display: block;
        //         font-size: 0.38rem;
        //         font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        //         font-weight: bold;
        //         color: #00E0DB;
        //         // line-height: 0.38rem;
        //         // padding-top: .11rem;
        //         // padding-left: .08rem;
        //     }

        //     div {
        //         // min-width: 3rem;
        //     }

        // }
    }

    .active_1 {
        color: #00FF9D !important;
    }
}
</style>
<style lang="scss">
.breeder {
    .breeder .dv-digital-flop canvas {
        text-align: left !important;
        width: 80% !important;
        height: 80% !important;
    }

    // .dv-digital-flop canvas {
    //     width: 80% !important;
    //     height: 80% !important;
    //     margin-left: .2rem !important;
    // }

    .active-ring-name {
        font-size: .23rem !important;
        padding-top: .1rem;
    }

    .el-input__inner {
        // width: 2.79rem;
        height: 0.44rem;
        background: rgba(0, 224, 219, 0.08) !important;
        border: none;
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: inherit;

    }

    .search_input>.el-input__inner {
        padding: 0 0 0 .4rem;
        //     background: url('../../assets/search\ \(1\).png') no-repeat;
        //    background-position: .1rem,.1rem;
    }


    .header {
        background: rgba(0, 224, 219, 0.08) !important;

    }

    // DataV
    .header-item {
        font-size: .175rem !important;
        opacity: .85;
    }

    .rows {
        padding: .2rem 0 .4rem 0;
    }

    .row-item {
        background: transparent !important;

        div:nth-child(7) {
            span {
                margin-left: .6rem !important;
            }
        }
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .ceil {
        font-size: .15rem !important;
    }

    .ceil:first-child {
        color: #FFC300;
    }

}
</style>